import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { Trash, Warning } from "@phosphor-icons/react";

/**
 * Reusable confirmation dialog for delete actions
 * Provides consistent visual style across the application
 */
export const ConfirmDeleteDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title = "Confirmar Eliminação",
  description = "Tem a certeza que deseja eliminar este item? Esta ação não pode ser desfeita.",
  itemName = null,
  itemType = "item", // "imagem", "projeto", "entrega", etc.
  showPreview = false,
  previewUrl = null,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md" data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-red-100 rounded-full">
              <Warning size={24} className="text-red-600" weight="fill" />
            </div>
            <AlertDialogTitle className="text-lg font-semibold text-stone-900">
              {title}
            </AlertDialogTitle>
          </div>
          
          {showPreview && previewUrl && (
            <div className="my-4 flex justify-center">
              <img 
                src={previewUrl} 
                alt="Preview" 
                className="max-h-32 max-w-full object-contain rounded-lg border border-stone-200 shadow-sm"
              />
            </div>
          )}
          
          <AlertDialogDescription className="text-stone-600">
            {itemName ? (
              <>
                Tem a certeza que deseja eliminar {itemType === "imagem" ? "esta" : "este"} <strong className="text-stone-800">{itemType}</strong>
                {itemName && itemName !== "this" && (
                  <> &ldquo;<span className="font-medium text-stone-800">{itemName}</span>&rdquo;</>
                )}
                ? Esta ação não pode ser desfeita.
              </>
            ) : (
              description
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel className="bg-stone-100 hover:bg-stone-200 text-stone-700 border-0" data-testid="confirm-delete-cancel-button">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="confirm-delete-button"
          >
            <Trash size={18} className="mr-2" />
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDeleteDialog;
